
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center">{{ prip.prip_title }}</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="3">Template header</v-col>
                    <v-col cols="9">{{ prip.mlhf_nr }} {{ prip.mlhf_oms }}</v-col>
                    <v-col cols="3">Template for</v-col>
                    <v-col cols="9">{{ prip.mltp_doelgroep }}</v-col>
                    <v-col cols="3">Type</v-col>
                    <v-col cols="3"><v-select v-model="prip.prip_type" label="Type" :items="prip.prip_type_opties" item-text="label" item-value="code"></v-select></v-col>
                    <v-col cols="6"></v-col>
                    <v-col cols="3">Change until (inclusive)</v-col>
                    <v-col cols="5">
                        <v-menu v-model="datmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="prip.prip_wijzig_tm_dat" label="Owner can change house list until" clearable v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="prip.prip_wijzig_tm_dat = $moment(hulpDate).format('DD-MM-YYYY'); datmenu = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="4"></v-col>
                    <v-col cols="3">Price improvement description</v-col>
                    <v-col cols="9"><v-textarea v-model="prip.prip_oms" label="Price improvement description" dense></v-textarea></v-col>
                </v-row>
                <v-divider/>
                <div class="pa-2">This will create a new prive action & tempate 'set' using the {{ prip.mlhf_nr }} ({{ prip.mlhf_oms }}) header & footer.</div>
                <div class="pa-2" v-if="prip.prip_source > 0">
                    It will copy Subject & mail texts for both 'Test' & 'Production' templates in all languages to the new tempate.
                </div>
                <div class="pa-2" v-else>
                    It will create empty Subject & mail texts for both 'Test' & 'Production' in all languages.
                </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="success" :disabled="prip.prip_oms === ''||prip.prip_type===''||prip.prip_wijzig_tm_dat===''" @click="savePrip" v-if="!prip.newPrip">Save</v-btn>
                <v-btn color="success" :disabled="prip.prip_oms === ''||prip.prip_type===''||prip.prip_wijzig_tm_dat===''" @click="createNewPrip" v-if="prip.newPrip">Create</v-btn>
                <v-btn color="error" @click="closeNewPrip">Cancel</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                datmenu: false,
                hulpDate: "",
                prip : {
                    prip_title: "",
                    prip_nr: 0,
                    mltp_doelgroep: "",
                    mlhf_nr: 0,
                    mlhf_oms: "",
                    prip_source: 0,
                    prip_oms: ""
                }
            }  
        },
        methods: {
            openNewPrip(prip_nr, newPrip) {
                this.$axios.post("ares/json/ares/syst/prip/getPripToAdd.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPripToAdd"
                    },
                    getPripToAdd: {
                        prip_nr: prip_nr,
                        newPrip: newPrip
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.prip =  res.data.getPripToAdd
                        this.dialog = true
                    }
                });
            },
            createNewPrip() {
                this.$axios.post("ares/json/ares/syst/prip/addPrip.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addPrip"
                    },
                    addPrip: {
                        prip: this.prip
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.addPrip.text,
                            color: res.data.addPrip.color
                        });
                        if (res.data.addPrip.color === "success") {
                            this.$emit("reload")
                            this.closeNewPrip()
                        }
                    }
                });
            },
            savePrip() {
                this.$axios.post("ares/json/ares/syst/prip/savePrip.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "savePrip"
                    },
                    savePrip: {
                        prip: this.prip
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.savePrip.text,
                            color: res.data.savePrip.color
                        });
                        if (res.data.savePrip.color === "success") {
                            this.$emit("reload")
                            this.closeNewPrip()
                        }
                    }
                });
            },
            closeNewPrip() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
</style>